import { OSM, TileWMS, WMTS, XYZ } from "ol/source";
import TileGrid from "ol/tilegrid/TileGrid";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { Layer, Tile as TileLayer } from "ol/layer";
import { mapTileGrid, wmtsTileGrid } from "./config";
import { getMap } from "./GeoLiteMap";

// one scale unit (if scale=1000, resolution=2.6458386250105836)
const lodResolutionUnit = 0.00026458386250105836;

const appid = encodeURI(window.location.host + window.location.pathname);

export const getBasemapLayers = (config): Layer[] => {
    const configResolutions = config.mapLods && config.mapLods.map((lod) => lod.resolution);
    const defaultTileGrid = mapTileGrid;
    configResolutions && (defaultTileGrid.resolutions = configResolutions);
    const tileGrid = new TileGrid(defaultTileGrid);

    return config.basemaps
        .map((b) => {
            if (b.type === "TileLayer") {
                const olLayer = new TileLayer({
                    source: new XYZ({
                        url: b.url + "/tile/{z}/{y}/{x}",
                        projection: b.projection,
                        tileGrid:
                            b?.maxScale >= 0 || b.maxLodLevel
                                ? getReducedTileGrid(
                                      defaultTileGrid,
                                      b.maxScale,
                                      b.maxLodLevel || defaultTileGrid.resolutions.length
                                  )
                                : tileGrid,
                        crossOrigin: b.crossOrigin || "Anonymous",
                        attributions: b.copyright
                    }),
                    visible: true,
                    properties: { id: b.id },
                    zIndex: 0
                });
                olLayer.setProperties(b);
                return olLayer;
            }
            if (b.type === "WMS") {
                const olLayer = new TileLayer({
                    source: new TileWMS({
                        url: b.url,
                        params: b.params,
                        projection: b.projection,
                        serverType: b.serverType,
                        crossOrigin: b.crossOrigin || "Anonymous",
                        tileGrid,
                        attributions: b.copyright,
                        hidpi: false,
                        // https://manidarbi.lvm.lv/browse/GDEV-4137
                        tileLoadFunction: (imageTile, src) => {
                            //@ts-ignore
                            imageTile.getImage().src = src + "&appid=" + appid;
                        }
                    }),
                    properties: { id: b.id },
                    visible: true,
                    zIndex: 0
                });
                olLayer.setProperties(b);
                return olLayer;
            }
            if (b.type === "WMTS") {
                const olLayer = new TileLayer({
                    source: new WMTS({
                        attributions: b.copyright,
                        url: b.url,
                        layer: b.layers[0].layers[0],
                        matrixSet: "LKS_LVM",
                        format: b.layers[0].imagetype,
                        projection: b.projection,
                        tileGrid: new WMTSTileGrid(wmtsTileGrid),
                        style: b.layers[0].style || "raster",
                        wrapX: true,
                        crossOrigin: b.crossOrigin || "Anonymous",
                        // https://manidarbi.lvm.lv/browse/GDEV-4137
                        tileLoadFunction: (imageTile, src) => {
                            //@ts-ignore
                            imageTile.getImage().src = src + "&appid=" + appid;
                        }
                    }),
                    properties: { id: b.id },
                    visible: true,
                    zIndex: 0
                });
                olLayer.setProperties(b);
                return olLayer;
            }
            // This is to test OSM source map straight from OSRM servers
            if (b.type === "OSM") {
                const olLayer = new TileLayer({
                    source: new OSM(),
                    properties: { id: b.id },
                    zIndex: 0
                });
                olLayer.setProperties(b);
                return olLayer;
            }
        })
        .filter((b) => b);
};

export const switchBasemap = (baseMap: string): void => {
    getMap()
        .getLayers()
        .getArray()
        .map((layer) => layer.get("isBaseMap") && layer.setVisible(layer.get("id") === baseMap));
};

export const getReducedTileGrid = (
    defaultTileGrid: {
        origin: number[];
        tileSize: number[];
        resolutions: number[];
    },
    maxScale = 0,
    maxLodLevel: number
): TileGrid => {
    const resolutions = [];
    defaultTileGrid.resolutions.map(
        (r, i) => r >= maxScale * lodResolutionUnit && i < maxLodLevel && resolutions.push(r) // TODO ņemt vērā arī minScale=250000 un noņemt no sākuma
    );

    return new TileGrid({
        origin: defaultTileGrid.origin,
        tileSize: defaultTileGrid.tileSize,
        resolutions
    });
};
